import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/**
 * Fetch all users (id, name, email only)
 */
export const fetchAllUserEmails = () =>
  api.get("/admin/users/all_user_email");

/**
 * Send email campaign
 */
export const sendEmail = (payload) =>
  api.post("/admin/email/send", payload);

